<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="商品ID" prop="goodsId" >
        <a-input v-model="form.goodsId" placeholder="请输入商品ID" />
      </a-form-model-item>
      <a-form-model-item label="商品名称" prop="goodsName" >
        <a-input v-model="form.goodsName" placeholder="请输入商品名称" />
      </a-form-model-item>
      <a-form-model-item label="订单类型:0-全款订单 1-首款订单 2-月结订单" prop="orderType" >
      </a-form-model-item>
      <a-form-model-item label="订单号" prop="orderNo" >
        <a-input v-model="form.orderNo" placeholder="请输入订单号" />
      </a-form-model-item>
      <a-form-model-item label="宽" prop="width" >
        <a-input v-model="form.width" placeholder="请输入宽" />
      </a-form-model-item>
      <a-form-model-item label="高" prop="height" >
        <a-input v-model="form.height" placeholder="请输入高" />
      </a-form-model-item>
      <a-form-model-item label="底" prop="bottom" >
        <a-input v-model="form.bottom" placeholder="请输入底" />
      </a-form-model-item>
      <a-form-model-item label="重量" prop="weight" >
        <a-input v-model="form.weight" placeholder="请输入重量" />
      </a-form-model-item>
      <a-form-model-item label="汇率值" prop="exchangeRate" >
        <a-input v-model="form.exchangeRate" placeholder="请输入汇率值" />
      </a-form-model-item>
      <a-form-model-item label="运费方式" prop="shippingMethod" >
        <a-input v-model="form.shippingMethod" placeholder="请输入运费方式" />
      </a-form-model-item>
      <a-form-model-item label="款式数量" prop="stylesNum" >
        <a-input v-model="form.stylesNum" placeholder="请输入款式数量" />
      </a-form-model-item>
      <a-form-model-item label="合计数量" prop="totalNum" >
        <a-input v-model="form.totalNum" placeholder="请输入合计数量" />
      </a-form-model-item>
      <a-form-model-item label="应付金额" prop="payMoney" >
        <a-input v-model="form.payMoney" placeholder="请输入应付金额" />
      </a-form-model-item>
      <a-form-model-item label="首款金额" prop="firstMoney" >
        <a-input v-model="form.firstMoney" placeholder="请输入首款金额" />
      </a-form-model-item>
      <a-form-model-item label="尾款金额" prop="finalMoney" >
        <a-input v-model="form.finalMoney" placeholder="请输入尾款金额" />
      </a-form-model-item>
      <a-form-model-item label="已付金额" prop="paidMoney" >
        <a-input v-model="form.paidMoney" placeholder="请输入已付金额" />
      </a-form-model-item>
      <a-form-model-item label="运费金额" prop="shippingMoney" >
        <a-input v-model="form.shippingMoney" placeholder="请输入运费金额" />
      </a-form-model-item>
      <a-form-model-item label="计算公式" prop="calculationFormula" >
        <a-input v-model="form.calculationFormula" placeholder="请输入计算公式" />
      </a-form-model-item>
      <a-form-model-item label="实际金额" prop="goodMoney" >
        <a-input v-model="form.goodMoney" placeholder="请输入实际金额" />
      </a-form-model-item>
      <a-form-model-item label="印刷米数" prop="printingMeters" >
        <a-input v-model="form.printingMeters" placeholder="请输入印刷米数" />
      </a-form-model-item>
      <a-form-model-item label="排版方式：0-正常 1-双放料" prop="typesettingType" >
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoodsOrder, addGoodsOrder, updateGoodsOrder } from '@/api/user/goodsOrder'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        goodsId: null,

        goodsName: null,

        orderType: null,

        orderStatus: 0,

        firstStatus: 0,

        finalStatus: 0,

        productionStatus: '0',

        orderNo: null,

        width: null,

        height: null,

        bottom: null,

        weight: null,

        exchangeRate: null,

        shippingMethod: null,

        stylesNum: null,

        totalNum: null,

        payMoney: null,

        firstMoney: null,

        finalMoney: null,

        paidMoney: null,

        shippingMoney: null,

        calculationFormula: null,

        goodMoney: null,

        printingMeters: null,

        typesettingType: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        orderNo: [
          { required: true, message: '订单号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        goodsId: null,
        goodsName: null,
        orderType: null,
        orderStatus: 0,
        firstStatus: 0,
        finalStatus: 0,
        productionStatus: '0',
        orderNo: null,
        width: null,
        height: null,
        bottom: null,
        weight: null,
        exchangeRate: null,
        shippingMethod: null,
        stylesNum: null,
        totalNum: null,
        payMoney: null,
        firstMoney: null,
        finalMoney: null,
        paidMoney: null,
        shippingMoney: null,
        calculationFormula: null,
        goodMoney: null,
        printingMeters: null,
        typesettingType: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGoodsOrder(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGoodsOrder(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
